/**
 * Memory-03 — Dicionário de vocabulário humano
 *
 * Banimento de jargão técnico em labels visíveis.
 * Use SEMPRE estas funções em UI; nunca exiba "decay_rate", "memory_layer",
 * "confidence", "embedding" cru para o operador.
 */

export const MEMORY_LAYER_LABEL: Record<string, string> = {
  recent: "Recente",
  episodic: "Recente",
  factual: "Padrão",
  semantic: "Padrão",
  operational: "Hábito",
  procedural: "Hábito",
};

export const MEMORY_TYPE_LABEL: Record<string, string> = {
  event: "Evento",
  fact: "Fato",
  decision: "Decisão",
  preference: "Preferência",
  knowledge: "Conhecimento",
};

export const PROVENANCE_LABEL: Record<string, string> = {
  user_message: "Veio de mensagem",
  operator_entry: "Adicionada pelo operador",
  consolidated: "Consolidada automaticamente",
  imported: "Importada",
};

/** Converte confidence (0–1) para "força" textual e percentual humano. */
export function strengthLabel(confidence?: number | null): { label: string; pct: number } {
  const c = Math.max(0, Math.min(1, confidence ?? 0));
  const pct = Math.round(c * 100);
  if (c >= 0.85) return { label: "Muito forte", pct };
  if (c >= 0.65) return { label: "Forte", pct };
  if (c >= 0.4) return { label: "Média", pct };
  if (c >= 0.2) return { label: "Fraca", pct };
  return { label: "Muito fraca", pct };
}

/** Converte decay_rate em descrição humana de esquecimento. */
export function forgettingLabel(decayRate?: number | null): string {
  const d = decayRate ?? 0;
  if (d === 0) return "Fixada (não esquece)";
  if (d <= 0.005) return "Esquece muito devagar";
  if (d <= 0.01) return "Esquece devagar";
  if (d <= 0.03) return "Esquece em ritmo normal";
  return "Esquece rápido";
}

/** Layer → aba do MemoryHub */
export function layerToTab(layer: string): "recente" | "padroes" | "oficial" | "habitos" {
  if (["recent", "episodic"].includes(layer)) return "recente";
  if (["operational", "procedural"].includes(layer)) return "habitos";
  return "padroes";
}
